import React, { useCallback, useEffect, useState } from 'react';
import type { CSSProp } from 'styled-components';

import * as styles from './LocalePanel.styles';
import { Flag } from 'client-site-chrome-ui/components/atoms/Flag/Flag';
import { useSiteChromeDynamicContext } from 'client-site-chrome-ui/context/SiteChromeDynamicContext/useSiteChromeDynamicContext';
import type { Placement } from 'client-site-chrome-ui/types/locale';
import { getCurrency } from 'client-site-chrome-ui/utils/getCurrency';

export interface LocalePanelProps {
  buttonStyles?: CSSProp;
  currencyStyles?: CSSProp;
  flagStyles?: CSSProp;
  headingStyles?: CSSProp;
  placement: Placement;
}

export const LocalePanel = ({
  buttonStyles,
  currencyStyles,
  flagStyles,
  headingStyles,
  placement,
}: LocalePanelProps) => {
  const {
    locale: [currentLocale],
    localeModal: { open },
  } = useSiteChromeDynamicContext();
  const currency = getCurrency(currentLocale.currency);
  const onClick = useCallback(() => open(placement), [open, placement]);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <div css={styles.container}>
      <h4 css={[styles.copy, styles.heading, headingStyles]}>Shopping in</h4>
      {isClient && (
        <Flag
          countryCode={currentLocale.countryCode}
          countryName={currentLocale.countryName}
          styles={[styles.flag, flagStyles]}
          width={20}
        />
      )}
      {isClient && currency && (
        <span css={[styles.copy, currencyStyles]}>
          {currency.symbol} {currency.code}
        </span>
      )}
      <button css={[styles.copy, styles.button, buttonStyles]} onClick={onClick} type="button">
        Change
      </button>
    </div>
  );
};
